import React from 'react';
import FontIcon from 'material-ui/FontIcon';

class LoginLogout extends React.PureComponent {
    render() {
        return (
            <FontIcon className="material-icons" style={{fontSize: 48, color: 'white'}}>account_circle</FontIcon>
        );
    }
}

export default LoginLogout;


// WEBPACK FOOTER //
// ./src/components/LoginLogout/index.jsx